var _excluded = ["block", "children", "className", "htmlFor"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { bool, node, string } from 'prop-types';
import classNames from 'classnames';

var Label = function Label(_ref) {
  var block = _ref.block,
      children = _ref.children,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("label", _extends({
    className: classNames('ffe-form-label', className, {
      'ffe-form-label--block': block
    }),
    htmlFor: htmlFor
  }, rest), children);
};

Label.propTypes = {
  /**
   * Labels default to `display: inline-block;` to have tooltips appear immediately to the right.
   * Set this to `true` if you don't use tooltips and need the label to be `display: block;`.
   */
  block: bool,
  children: node.isRequired,
  className: string,
  htmlFor: string
};
export default Label;